import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  InputAdornment,
  Paper,
  IconButton,
  Typography,
  Tooltip,
} from "@mui/material";
import { Search as SearchIcon, Clear as ClearIcon } from "@mui/icons-material";

const OpexSearchBox = ({ onSearch, userEmail }) => {
  const [contract, setContract] = useState("");
  const [esercizio, setEsercizio] = useState("");
  const [conto, setConto] = useState("");
  const [cdc, setCdc] = useState("");
  const [meseFiscale, setMeseFiscale] = useState("");
  const [oda, setOda] = useState("");
  const [buyer, setBuyer] = useState("");
  const [defaultBuyer, setDefaultBuyer] = useState("");

  // Funzione per estrarre il nome utente dall'email
  const extractUsernameFromEmail = (email) => {
    if (!email) return "";
    const username = email.split("@")[0];
    return username.toUpperCase();
  };

  // Effect per impostare il buyer di default quando l'email cambia
  useEffect(() => {
    if (userEmail) {
      const extractedBuyer = extractUsernameFromEmail(userEmail);
      setDefaultBuyer(extractedBuyer);
      // Imposta il buyer solo se è ancora vuoto (al primo caricamento)
      if (!buyer) {
        setBuyer(extractedBuyer);
      }
    }
  }, [userEmail]); // Rimosso buyer dalle dipendenze per evitare loop

  // Effect separato per aggiornare il buyer quando cambia defaultBuyer
  useEffect(() => {
    if (defaultBuyer && !buyer) {
      setBuyer(defaultBuyer);
    }
  }, [defaultBuyer]);

  const handleSearch = () => {
    onSearch({
      contract: contract.trim(),
      esercizio: esercizio.trim(),
      conto: conto.trim(),
      cdc: cdc.trim(),
      meseFiscale: meseFiscale.trim(),
      oda: oda.trim(),
      buyer: buyer.trim(),
    });
  };

  const handleClear = () => {
    setContract("");
    setEsercizio("");
    setConto("");
    setCdc("");
    setMeseFiscale("");
    setOda("");
    setBuyer(""); // Svuota anche il buyer per ricerca completa

    onSearch({
      contract: "",
      esercizio: "",
      conto: "",
      cdc: "",
      meseFiscale: "",
      oda: "",
      buyer: "", // Ricerca senza filtro buyer
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const commonTextFieldProps = {
    variant: "outlined",
    size: "small",
    onKeyPress: handleKeyPress,
    InputProps: {
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon fontSize="small" color="action" sx={{ fontSize: 16 }} />
        </InputAdornment>
      ),
    },
    sx: {
      "& .MuiOutlinedInput-root": {
        height: "36px",
      },
    },
  };

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        mb: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <Typography
          variant="caption"
          sx={{ fontWeight: "bold", color: "text.secondary", mr: 1 }}
        >
          Ricerca:
        </Typography>

        <Box sx={{ display: "flex", gap: 0.5, ml: "auto" }}>
          <Tooltip title="Cerca">
            <IconButton
              color="primary"
              onClick={handleSearch}
              size="small"
              sx={{
                bgcolor: "primary.main",
                color: "white",
                "&:hover": { bgcolor: "primary.dark" },
                width: "30px",
                height: "30px",
              }}
            >
              <SearchIcon fontSize="small" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Pulisci">
            <IconButton
              onClick={handleClear}
              size="small"
              sx={{
                bgcolor: "grey.200",
                "&:hover": { bgcolor: "grey.300" },
                width: "30px",
                height: "30px",
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
        <TextField
          {...commonTextFieldProps}
          placeholder="Contract"
          value={contract}
          onChange={(e) => setContract(e.target.value)}
          sx={{ ...commonTextFieldProps.sx, minWidth: "120px", flex: 1 }}
        />
        <TextField
          {...commonTextFieldProps}
          placeholder="Esercizio"
          value={esercizio}
          onChange={(e) => setEsercizio(e.target.value)}
          sx={{ ...commonTextFieldProps.sx, minWidth: "120px", flex: 1 }}
        />
        <TextField
          {...commonTextFieldProps}
          placeholder="Conto"
          value={conto}
          onChange={(e) => setConto(e.target.value)}
          sx={{ ...commonTextFieldProps.sx, minWidth: "120px", flex: 1 }}
        />
        <TextField
          {...commonTextFieldProps}
          placeholder="CDC"
          value={cdc}
          onChange={(e) => setCdc(e.target.value)}
          sx={{ ...commonTextFieldProps.sx, minWidth: "120px", flex: 1 }}
        />
        <TextField
          {...commonTextFieldProps}
          placeholder="Mese Fiscale"
          value={meseFiscale}
          onChange={(e) => setMeseFiscale(e.target.value)}
          sx={{ ...commonTextFieldProps.sx, minWidth: "120px", flex: 1 }}
        />
        <TextField
          {...commonTextFieldProps}
          placeholder="Oda"
          value={oda}
          onChange={(e) => setOda(e.target.value)}
          sx={{ ...commonTextFieldProps.sx, minWidth: "120px", flex: 1 }}
        />
        <TextField
          {...commonTextFieldProps}
          placeholder="Buyer"
          value={buyer}
          onChange={(e) => setBuyer(e.target.value)}
          sx={{
            ...commonTextFieldProps.sx,
            minWidth: "120px",
            flex: 1,
            "& .MuiOutlinedInput-root": {
              ...commonTextFieldProps.sx["& .MuiOutlinedInput-root"],
              backgroundColor:
                buyer === defaultBuyer && buyer ? "#f8f9ff" : "transparent",
            },
          }}
        />
      </Box>
    </Paper>
  );
};

export default OpexSearchBox;
